export * from './SplitColorTitle';
